// @TODO: использовать утилитные методы приложения
// eslint-disable-next-line no-negated-condition
export const userAgent = () => (typeof window !== 'undefined' ? window.navigator.userAgent : '');

export function isDesktopApp(): boolean {
    const UA = userAgent();
    const isMattermostUserAgent = UA.indexOf('Mattermost') !== -1;
    const isTiMeUserAgent = UA.indexOf('TiMe') !== -1;

    return (isMattermostUserAgent || isTiMeUserAgent) && UA.indexOf('Electron') !== -1;
}
